import { gql } from '@/__generated__';

const UPDATE_DGA_SCHEDULE = gql(`#graphql
  mutation UpdateDgaSchedule($deviceId: ID!, $input: UpdateDgaScheduleInput!) {
    updateDgaSchedule(deviceId: $deviceId, input: $input) {
      id
      dga {
        id
        configuration {
          id
          code
          rut
          password
          type
          frequency
          hour
          weekday
          day
          enabled
          dataDelayInHours
          startTimestamp
        }
      }
    }
  }
`);

export default UPDATE_DGA_SCHEDULE;
